import { getSvgIcon } from '@helpers/icons';
import * as React from 'react';
import S from '../SocialLinks/SocialLinks.styles';
export var ShareLinkIcon;
(function (ShareLinkIcon) {
    ShareLinkIcon["Facebook"] = "facebook";
    ShareLinkIcon["LinkedIn"] = "linkedin";
    ShareLinkIcon["X"] = "x";
    ShareLinkIcon["Copy"] = "copylink";
})(ShareLinkIcon || (ShareLinkIcon = {}));
const DEFAULT_ICONS = [
    ShareLinkIcon.LinkedIn,
    ShareLinkIcon.X,
    ShareLinkIcon.Facebook,
    ShareLinkIcon.Copy,
];
const ShareLinks = ({ icons = DEFAULT_ICONS, pageName, url }) => {
    const copyLink = (e) => {
        e.preventDefault();
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(url)
                .catch((err) => console.error('Failed to copy: ', err));
        }
        else {
            const textArea = document.createElement('textarea');
            textArea.value = url;
            textArea.style.position = 'fixed';
            textArea.style.top = '0';
            textArea.style.left = '0';
            textArea.style.opacity = '0';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
                document.execCommand('copy');
            }
            catch (err) {
                console.error('Fallback: Unable to copy', err);
            }
            document.body.removeChild(textArea);
        }
    };
    const getHref = (item) => {
        switch (item) {
            case ShareLinkIcon.Facebook:
                return getFacebookUrl(url);
            case ShareLinkIcon.LinkedIn:
                return getLinkedInUrl(url, pageName);
            case ShareLinkIcon.X:
                return getXUrl(url, pageName);
            default:
                return '';
        }
    };
    return (React.createElement(S.Container, { "data-share": true }, icons.map((item) => (React.createElement(S.Item, { key: `ShareLinks_${item}` }, item === ShareLinkIcon.Copy ? (React.createElement(S.Button, { onClick: copyLink, title: "Copy link", "aria-label": "Copy link" }, getSvgIcon(item))) : (React.createElement(S.Link, { target: "_blank", as: "a", href: getHref(item), title: item }, renderIcon(item))))))));
    function renderIcon(type) {
        if (!Object.values(ShareLinkIcon).includes(type)) {
            console.error(`Unsupported icon type`, type);
            return null;
        }
        return getSvgIcon(type);
    }
};
export default ShareLinks;
function getFacebookUrl(url) {
    return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
}
function getLinkedInUrl(url, pageName) {
    return `https://www.linkedin.com/shareArticle?title=${encodeURIComponent(pageName)}&url=${encodeURIComponent(url)}`;
}
function getXUrl(url, pageName) {
    return `https://twitter.com/intent/tweet?text=${encodeURIComponent(pageName)}&url=${encodeURIComponent(url)}`;
}
